import { useRouter } from "@tanstack/react-router";
import { useMemo } from "react";

type ThemeConfig = {
  headerBackgroundColor: string;
  themeMode: "light" | "blue";
  bodyBackgroundColor: string;
  enableFooter: boolean;
};

type ThemeEndpoint =
  | "/triage/ib"
  | "/default"
  | "/triage/mam"
  | "/program-selection"
  | "/kyc"
  | "/questionnaire";

const THEME_CONFIG: Record<ThemeEndpoint, ThemeConfig> = {
  "/triage/ib": {
    headerBackgroundColor: "bg-grey-100 lg:bg-surface-secondary",
    themeMode: "light",
    bodyBackgroundColor: "lg:bg-surface-secondary",
    enableFooter: false,
  },
  "/kyc": {
    headerBackgroundColor: "bg-grey-100 lg:bg-surface-secondary",
    themeMode: "light",
    bodyBackgroundColor: "lg:bg-surface-secondary",
    enableFooter: false,
  },
  "/questionnaire": {
    headerBackgroundColor: "bg-grey-100 lg:bg-surface-secondary",
    themeMode: "light",
    bodyBackgroundColor: "lg:bg-surface-secondary",
    enableFooter: false,
  },
  "/program-selection": {
    headerBackgroundColor: "bg-surface-secondary",
    themeMode: "light",
    bodyBackgroundColor: "lg:bg-surface-secondary",
    enableFooter: false,
  },
  "/triage/mam": {
    headerBackgroundColor: "bg-surface-emphasis",
    themeMode: "blue",
    bodyBackgroundColor: "bg-white",
    enableFooter: false,
  },
  "/default": {
    headerBackgroundColor: "bg-surface-emphasis",
    themeMode: "blue",
    bodyBackgroundColor: "bg-white",
    enableFooter: true,
  },
};

export const useThemeByPath = (): ThemeConfig => {
  const router = useRouter();
  const pathname = router?.state?.location?.pathname || "";

  const theme = useMemo(() => {
    const matchedEndpoint =
      (Object.keys(THEME_CONFIG).find((endpoint) =>
        pathname?.startsWith(endpoint),
      ) as ThemeEndpoint) || "/default";

    return THEME_CONFIG[matchedEndpoint];
  }, [pathname]);

  return theme;
};
